import { AxiosResponse } from 'axios';
import v1 from '../v1';

export async function findList(center: ILngLat, radius: number, coordinateSystem: string = 'wgs84'): Promise<AxiosResponse<any>> {
  return await v1({
    url: `operation/backlogPoint`,
    params: {
      center,
      radius,
      coordinateSystem,
    },
  });
}

export async function create(name: string, radius: number, warningNumber: number, coordinates: ILngLat): Promise<AxiosResponse<any>> {
  return await v1({
    url: 'operation/backlogPoint',
    method: 'post',
    data: { coordinates, radius, name, warningNumber },
  });
}

export async function remove(id: string): Promise<void> {
  await v1({
    url: 'operation/backlogPoint',
    method: 'delete',
    data: {
      id,
    },
  });
}

export async function updateProperties(name: string, radius: number, warningNumber: number, id: string): Promise<AxiosResponse<any>> {
  return v1({
    url: `operation/backlogPoint/${id}`,
    method: 'put',
    data: { radius, name, warningNumber },
  });
}

export async function updateLocation(id: string, coordinates: any): Promise<AxiosResponse<any>> {
  return v1({
    url: `operation/backlogPoint/${id}/lngLat`,
    method: 'put',
    data: { coordinates },
  });
}

export async function refreshBacklogPoint(center: ILngLat, radius: number, coordinateSystem: string = 'wgs84'): Promise<AxiosResponse<any>> {
  return v1({
    url: 'operation/backlogPoint/refresh',
    method: 'put',
    data: {
      center, radius, coordinateSystem,
    },
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/backlogPoint.ts